import { 
    LOAD_FIRMWARE_DATA_IN_PROGRESS,
    LOAD_FIRMWARE_DATA_SUCCESS,
    LOAD_FIRMWARE_DATA_FAILURE,
    FILES_OPERATION_COMPLETED,
    LOAD_CONFIG_DATA_IN_PROGRESS,
    LOAD_CONFIG_DATA_SUCCESS,
    LOAD_DEFAULT_CONFIG_FILE_DATA_SUCCESS,
    LOAD_CONFIG_DATA_FAILURE,
    LOAD_DEVICE_DATA_IN_PROGRESS,
    OPEN_FIRMWARE_DIALOG,
    CLOSE_FIRMWARE_DIALOG,
    OPEN_CONFIG_DIALOG,
    CLOSE_CONFIG_DIALOG,
    SUCCESS_MESSAGE_DIALOG_BOX,
    SUCCESS_MESSAGE_DIALOG_BOX_CLOSE,
    ERROR_MESSAGE_DIALOG_BOX_CLOSE,
    ERROR_MESSAGE_DIALOG_BOX
  } from "./actions";
  
    const initialState = { isLoading: false, firmwaresData: [] , configData:[], defaultConfigFileData:[],successMessage:'',errorMessage:''};
  
    export const files = (state = initialState, action) => {
        const { type, payload } = action;
        switch (type) {
            case LOAD_FIRMWARE_DATA_SUCCESS: {
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    firmwaresData: data,
                };
            }     
            case LOAD_FIRMWARE_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            case LOAD_FIRMWARE_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            };

            case LOAD_CONFIG_DATA_SUCCESS: {
                const { data } = payload;
                return {
                  ...state,
                  isLoading: false,
                  configData: data,
                };
            };
            case LOAD_DEFAULT_CONFIG_FILE_DATA_SUCCESS: {
                const { data } = payload;
                return {
                  ...state,
                  isLoading: false,
                  defaultConfigFileData: data,
                };
            };
            case LOAD_CONFIG_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            case LOAD_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            }; 

            
            case LOAD_DEVICE_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            
            case FILES_OPERATION_COMPLETED:
            return {
                ...state,
                isLoading: false,
            }; 

            case OPEN_FIRMWARE_DIALOG:
            return {
                ...state,
                isFirmwareDialogOpen: true,
            }; 

            case CLOSE_FIRMWARE_DIALOG:
            return {
                ...state,
                isFirmwareDialogOpen: false,
            }; 

            case OPEN_CONFIG_DIALOG:
            return {
                ...state,
                isConfigDialogOpen: true,
            }; 

            case CLOSE_CONFIG_DIALOG:
            return {
                ...state,
                isConfigDialogOpen: false,
            }

            case SUCCESS_MESSAGE_DIALOG_BOX: {
                const { data } = payload;
                return {
                    ...state,
                    isSuccessDialogOpen: true,
                    successMessage: data
                }
            }

            case SUCCESS_MESSAGE_DIALOG_BOX_CLOSE: {
                return {
                    ...state,
                    isSuccessDialogOpen: false,
                    successMessage: '',
                }
            }
            
            case ERROR_MESSAGE_DIALOG_BOX: {
                const { data } = payload;
                return {
                    ...state,
                    isErrorDialogOpen: true,
                    errorMessage: data
                }
            }
        
            case ERROR_MESSAGE_DIALOG_BOX_CLOSE: {
                return {
                    ...state,
                    isErrorDialogOpen: false,
                }
            }
            default:
                return state;
        }
    };
  